// export function convertToLocalTime(utcString) {
//   try {
//     if (!utcString) return "Invalid Date";

//     const [datePart, timePart] = utcString.split(" ");
//     const [year, month, day] = datePart.split("-").map(Number);
//     const [hour, minute, secondWithMs] = timePart.split(":");
//     const [secondStr, microStr] = secondWithMs.split(".");

//     const second = parseInt(secondStr, 10);
//     const millisecond = parseInt(
//       (microStr || "0").slice(0, 3).padEnd(3, "0"),
//       10
//     );
//     const utcDate = new Date(
//       Date.UTC(year, month - 1, day, hour, minute, second, millisecond)
//     );

//     return utcDate.toLocaleString();
//   } catch (error) {
//     console.warn("Failed to convert UTC to local time:", utcString);
//     return "Invalid Date";
//   }
// }

export function convertToLocalTime(utcString) {
  try {
    if (!utcString) return "Invalid Date";

    const utcDate = new Date(utcString);
    if (isNaN(utcDate.getTime())) {
      return "Invalid Date";
    }

    return utcDate.toLocaleString();
  } catch (error) {
    console.warn("Failed to convert UTC to local time:", utcString);
    return "Invalid Date";
  }
}

export function filterSingleDeviceData(log) {
  const rawData = log || {}; // no need for log.data
  const valve1Data = {};
  const valve2Data = {};
  const timestamp =
    log.user_local_t || log.local_t || log.gw_time_parsed || log._time;

  Object.entries(rawData).forEach(([key, value]) => {
    if (typeof value !== "number") return;

    if (key.startsWith("v1_")) {
      valve1Data[key] = value;
    } else if (key.startsWith("v2_")) {
      valve2Data[key] = value;
    }
  });

  valve1Data.timestamp = timestamp;
  valve2Data.timestamp = timestamp;

  return { valve1Data, valve2Data };
}
